/* eslint-disable @typescript-eslint/no-unused-vars */
import { createMockAdminAssessments } from '__mocks__/adminAssessments';
import { createMockFoldersWithSubfolders } from '__mocks__/folders';
import { createMockLeaders } from '__mocks__/leader';
import { http, HttpResponse } from 'msw';
import { AssessmentStatus } from 'types/AssessmentStatus';

const getRandomLeaders = (leaders: Leader[], n: number): Leader[] => {
  const shuffled = leaders.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
};

const getRandomFolder = (folders: Folder[], n: number): Folder[] => {
  const shuffled = folders.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
};

export default function generateMocks(baseUrl?: string) {
  const lpiApiBaseUrl = `${baseUrl}/lpi/api/v4`;

  const leaderList = createMockLeaders(100);
  const folderList = createMockFoldersWithSubfolders(100);
  const assessmentList = Array.from({ length: 100 }, () => {
    const randomLeader = getRandomLeaders(leaderList, 1)[0];
    const randomFolder = getRandomFolder(folderList, 1)[0];
    return createMockAdminAssessments({
      length: 1,
      leader: randomLeader,
      folder: randomFolder,
      product: ['lpi-360', 'lpi-360-plus'],
      status: AssessmentStatus.COMPLETED,
    })[0];
  });

  return [
    http.get<never, never, { items: Leader[] }>(
      `${lpiApiBaseUrl}/lpi-leaders/search`,
      async ({ request }) => {
        const url = new URL(request.url);

        const keyword = url.searchParams.get('keyword');
        const email = url.searchParams.get('email');

        let data = [...leaderList];

        if (email) {
          data = data.filter((leader) => leader.email.toLowerCase() === email.toLowerCase());
        }

        if (keyword) {
          const lowerCaseKeyword = keyword.toLowerCase();

          data = data.filter((leader) =>
            leader.firstName.toLowerCase().includes(lowerCaseKeyword) ||
            leader.lastName.toLowerCase().includes(lowerCaseKeyword),
          );
        }

        return HttpResponse.json({ items: data });
      },
    ),
    http.post<never, any, { items: Folder[], count: number }>(
      `${baseUrl}/api/v4/folders/search`,
      async ({ request }) => {
        const url = new URL(request.url);
        const queryParams = new URLSearchParams(url.search);

        const offset = parseInt(queryParams.get('offset') || '0', 10);
        const size = parseInt(queryParams.get('size') || '10', 10);

        const requestBody = await request.json();
        const term = requestBody.request.keyword || '';

        let filteredItems = [...folderList];
        if (term) {
          filteredItems = folderList.filter((item) => (
            item.folderName.toLowerCase().includes(term)
            || item.subFolders?.some((child) => child.subFolderName.toLowerCase().includes(term))
          ));
        }

        const paginatedItems = filteredItems.slice(offset, offset + size);
        return  HttpResponse.json({ items: paginatedItems, count: paginatedItems.length });
      },
    ),
  ];
}
